import _taggedTemplateLiteral from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { Typography } from '../../../style/styled';
var Text = styled(Typography)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-family: var(--primary-font-family); //todo, improve or make this component style agnostic if possible\n    font-size: inherit;\n    font-stretch: inherit;\n    font-style: inherit;\n    letter-spacing: inherit;\n    font-weight: inherit;\n    line-height: inherit;\n    color: inherit;\n"])));
export default {
  Text: Text
};